"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA_EVENT_CRITEO = void 0;
const common_utils_1 = require("@as-react/common-utils");
exports.GA_EVENT_CRITEO = 'criteodata';
const checkIfCriteoEventIsAlreadyFired = (dataLayer) => dataLayer.some(item => item.event === exports.GA_EVENT_CRITEO);
const Criteo = ({ windowVariableName = 'SITE.data.criteoPageObj', dataLayerName = 'dataLayer', pageTypeVariable = 'SITE.Config.analyticsPageType', } = {}) => events => {
    if (typeof window === 'undefined') {
        return;
    }
    let criteoPageObject = (0, common_utils_1.getCustomWindowObject)(windowVariableName);
    if (!criteoPageObject) {
        criteoPageObject = Object.assign({}, (0, common_utils_1.mergeObjectDeep)({}, ...events));
        (0, common_utils_1.setCustomWindowObject)(windowVariableName, criteoPageObject);
    }
    criteoPageObject = Object.assign({}, (0, common_utils_1.mergeObjectDeep)(criteoPageObject, ...events));
    const pageType = (0, common_utils_1.getCustomWindowObject)(pageTypeVariable);
    const dataLayer = window[dataLayerName];
    let addEventToGoogleAnalytics = false;
    if (criteoPageObject.HashedEmail) {
        criteoPageObject.event = exports.GA_EVENT_CRITEO;
        criteoPageObject.SiteType = /Mobi|Android/i.test(navigator.userAgent) ? 'm' : 'd';
        if (criteoPageObject.HashedEmail == 'anonymous') {
            criteoPageObject.HashedEmail = '';
        }
        switch (pageType) {
            case 'product':
            case 'cart':
            case 'brands':
            case 'search':
            case 'lister':
            case 'category':
                if (criteoPageObject.ProductID && checkIfCriteoEventIsAlreadyFired(dataLayer) === false) {
                    addEventToGoogleAnalytics = true;
                }
                break;
            case 'purchase':
                if (criteoPageObject.ProductID &&
                    criteoPageObject.TransactionID &&
                    checkIfCriteoEventIsAlreadyFired(dataLayer) === false) {
                    addEventToGoogleAnalytics = true;
                }
                break;
            case 'home':
                if (checkIfCriteoEventIsAlreadyFired(dataLayer) === false) {
                    addEventToGoogleAnalytics = true;
                }
                break;
            default:
                break;
        }
    }
    if (addEventToGoogleAnalytics) {
        dataLayer.push(criteoPageObject);
        (0, common_utils_1.setCustomWindowObject)(windowVariableName, undefined);
    }
};
exports.default = Criteo;
//# sourceMappingURL=criteo.js.map